<script setup lang="ts">
const { initSmarticoError, isReadyGamefication } =
  storeToRefs(useSmarticoInit());

const { isGamificationTournamentsActived } = storeToRefs(useSmarticoConfigs());

const loadComponent = computed(() => {
  return (
    isGamificationTournamentsActived.value &&
    !initSmarticoError.value &&
    isReadyGamefication.value
  );
});

onMounted(() => {
  // Mark that we're on a tournament detail page, so when user goes back, filters can be restored
  if (typeof window !== 'undefined') {
    try {
      sessionStorage.setItem('casino_navigation_from_game', 'true');

      // If we didn't come from the tournaments list, clear the origin URL
      // This prevents incorrect navigation when going back from detail -> list -> back
      const referrer = document.referrer;
      const isFromTournamentsList =
        referrer &&
        referrer.includes('/vip/tournaments') &&
        !referrer.match(/\/vip\/tournaments\/\d+/);

      if (!isFromTournamentsList) {
        sessionStorage.removeItem('casino_origin_url');
      }
    } catch (e) {
      // Ignore storage errors
    }
  }
});
</script>

<template>
  <div :class="$style.centerPage">
    <SmarticoAlertsAndLoader
      v-if="!loadComponent"
      :force-show-error="!isGamificationTournamentsActived"
    />
    <SmarticoApostatudoTournamentSingle v-else />
  </div>
</template>

<style module lang="postcss">
.centerPage {
  @apply w-full min-h-[600px] flex flex-col relative -mt-1 lg:-mt-4;
}
</style>
